import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-note-participant-item',
  templateUrl: './operation-note-participant-item.component.html',
  styleUrls: ['./operation-note-participant-item.component.scss']
})
export class OperationNoteParticipantItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
